<template>
  <a-modal
    title="添加过滤条件"
    width="800px"
    :open="open"
    transitionName=""
    maskTransitionName=""
    :destroyOnClose="true"
    :confirmLoading="loading"
    centered
    @ok="handleSubmit"
    @cancel="
      () => {
        $emit('cancel');
      }
    "
  >
    <a-tabs v-model:activeKey="activeKey">
      <a-tab-pane
        class="my-card"
        v-for="item in tab_list"
        :key="item.key"
        :tab="item.tab_name"
      >
        <div
          v-for="base_search_item in item.base_search_list"
          :key="base_search_item.name"
        >
          <div style="font-size: 14px">{{ base_search_item.name }}</div>
          <a-space
            wrap
            style="padding-left: 10px; margin-bottom: 0"
          >
            <div
              v-for="obj in base_search_item.group"
              :key="obj.field_name"
            >
              <a-checkbox v-model:checked="obj.checked">
                <span style="color: #7d8089">{{ obj.label }}</span>
              </a-checkbox>
            </div>
          </a-space>
        </div>
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent, reactive, ref } from 'vue';

export default defineComponent({
  name: 'AddConditionModal',
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
    },
    default_search_condition_config_list: {
      type: Array,
      required: false,
    },
    base_search_condition_config_list: {
      type: Array,
      required: false,
    },
  },
  emits: ['ok', 'cancel'],
  setup(props, { emit }) {
    const activeKey = ref('condition_tab_0');
    const tab_list = ref([]);
    props.default_search_condition_config_list.forEach((item_list: any, index: number) => {
      const base_search_list: any = JSON.parse(
        JSON.stringify(props.base_search_condition_config_list),
      );
      if (base_search_list) {
        base_search_list.forEach((base_search_list: any) => {
          base_search_list.group.forEach(i => {
            item_list.forEach((k: any) => {
              if (i.field_name == k.field_name) {
                i.operator = k.operator;
                i.checked = true;
              }
            });
          });
        });
      }
      tab_list.value.push({
        tab_name: `条件组${index + 1}`,
        key: `condition_tab_${index}`,
        base_search_list: base_search_list,
      });
    });
    const handleSubmit = (e: Event) => {
      e.preventDefault();
      const list = [];
      tab_list.value.forEach(item => {
        const selected_group_list: any = [];
        item.base_search_list.forEach(i => {
          i.group.forEach((temp: any) => {
            if (temp.checked) {
              if (!temp.operator) {
                const operator_list_selected = get_operator_list_selected(temp);
                if (operator_list_selected.length > 0) {
                  const [first] = operator_list_selected;
                  temp.operator = first;
                }
              }
              selected_group_list.push(temp);
            }
          });
        });
        list.push(selected_group_list);
      });
      emit('ok', { new_list: list });
    };
    const get_operator_list_selected = (condition) => {
      if (condition.operator_list_selected) {
        return condition.operator_list_selected;
      }
      else if (condition.operator_list) {
        return condition.operator_list;
      }
      else {
        return [];
      }
    };

    return {
      props,
      activeKey,
      tab_list,
      handleSubmit,
    };
  },
});
</script>
<style scoped>
.my-card {
  padding: 20px;
  background-color: #f6f7f9;
}
</style>
